export default __webpack_public_path__ + "e4aae96132f9fa859b51a1ed2f385dc9.svg";